import { Grid, IconButton } from "@material-ui/core";
import { vendorContactStyle } from './style';
import { IconEdit, IconDeleteBlue } from "icons";
import NotificationProvider from "components/NotificationProvider";
import usePrompt from "hooks/usePrompt";
import { useDeleteContactMutation } from "./vendorContactSlice";
import UpdateContactDialog from "./UpdateContactDialog";
import { useState } from "react";
import { vendorContactPocTypes, vendorContactPocTypesObject, vendorContactTypes, vendorContactTypesObject } from "features/vms/consts";
import { userHasOneClient } from "features/user/userSlice";
import React from "react";
import { useSelector } from "react-redux";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { arrayToObject } from "utils/object-util";

export const VendorContact = ({ contact, hasPrimaryContact }) => {
    const classes = vendorContactStyle();
    const { triggerPrompt } = usePrompt();
    const hasOneClaim = useSelector(userHasOneClient);

    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery();
    const clientAccounts = clients?.flatMap(c => c.clientAccounts);

    const clientsLookup = arrayToObject(clientAccounts);

    const [openUpdateDialog, setOpenUpdateDialog] = useState(false);

    let [deleteContact, { isLoading: isDeleting }] = useDeleteContactMutation();

    const onDelete = async () => {
        triggerPrompt({
            title: "Delete Contact",
            content: "Are you sure you want to delete the contact?",
            onConfirm: async () => {
                const res = await deleteContact(contact?.id)

                if (!res?.error) {
                    NotificationProvider.success('Successfully deleted contact');
                } else {
                    NotificationProvider.error('Failed to delete contact');
                }
            },
        });
    }

    return (
        <>
            <Grid item xs={6} key={contact.id}>
                <div className={classes.contactItem} style={{ position: 'relative' }}>
                    {!contact.vmsLevel && <div style={{ position: 'absolute', top: 8, right: 8, display: 'flex' }}>
                        <IconButton onClick={() => setOpenUpdateDialog(true)}><IconEdit /></IconButton>
                        <IconButton onClick={onDelete}><IconDeleteBlue width={16} /></IconButton>
                    </div>}
                    <div className={classes.types}>
                        {contact.type == vendorContactTypes.PRIMARY &&
                            <div className={classes.contactType}>{vendorContactTypesObject[contact.type]}</div>
                        }
                        {contact.pocType == vendorContactPocTypes.NewRequests &&
                            <div className={classes.contactPocType}>{vendorContactPocTypesObject[contact.pocType]}</div>
                        }
                    </div>
                    {!hasOneClaim && <div><strong>Client:</strong> {clientsLookup?.[contact?.clientAccountId]?.name || '-'}</div>}
                    <div><strong>Name:</strong> {contact.name || '-'}</div>
                    <div><strong>Phone:</strong> {contact.phoneNumber || '-'}</div>
                    <div><strong>Email:</strong> {contact.email || '-'}</div>
                    <div>
                        <strong>Address:</strong>{" "}
                        {[contact.address, contact.city, contact.state, contact.zip].filter(Boolean).join(', ') || '-'}
                    </div>
                </div>
            </Grid>
            <UpdateContactDialog
                open={openUpdateDialog}
                onClose={() => setOpenUpdateDialog(false)}
                contact={contact}
                hasPrimaryContact={hasPrimaryContact} />
        </>
    )
}
